import { getZonedDate } from '@eika-infrastruktur/date';

const createDateToday = () => {
    const today = getZonedDate();
    today.setHours(0, 0, 0, 0);
    return today;
};

// eslint-disable-next-line import/prefer-default-export
export const invalidDate = (paymentDate?: Date): boolean => !!paymentDate && paymentDate < createDateToday();
